var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',_vm._g(_vm._b({},'wrap',_vm.$props,false),_vm.$listeners),[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center justify-content-center h-100"},[_c('b-spinner')],1):(_vm.displayElement)?_c('display-element',{attrs:{"display-element":_vm.displayElement,"labels":{
      previous: _vm.$t('recordList.pagination.prev'),
      next: _vm.$t('recordList.pagination.next'),
    }},on:{"update":_vm.getDataframes}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }